var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NoContent',{attrs:{"createActivityDisabled":!_vm.featureCreateActivityEnabled},on:{"create":function($event){return _vm.$emit('createActivity')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }